import SlideShowBanner from './SlideshowBanner'

export default SlideShowBanner
